<template>
  <div>
    <div v-if="this.loadingProperty" class="loader">Loading...</div>
    <div v-else>
      <div>
      
        <CreateAssetForm
          v-if="this.toggleCreateAssetForm == true"
          :property="this.propertyData"
          :canDownloadCsv="this.propertyassets.candownloadcsv"
          v-on:new-asset="addNewAssetLocally($event)"
          v-on:new-asset-list="addNewAssetListLocally($event)"
          v-on:close-CreateAssetForm="toggleCreateAssetFormmethod()"
        />
        <EditAssetForm
          v-if="this.toggleEditAssetForm == true"
          :machine="this.currenteditedasset"
          :property="this.propertyData"
          v-on:update-asset-locally="updateAssetLocally($event)"
          v-on:close-EditAssetForm="toggleEditAssetFormmethod()"
        />
        <DeleteAssetForm
          v-if="this.toggleDeleteAssetForm == true"
          :machine="this.currentdeletingasset"
          v-on:machine-deleted="deleteAssetLocally($event)"
          v-on:close-DeleteAssetForm="toggledeleteassetformmethod()"
        />
      </div>
      <div
        v-show="
          this.toggleCreateAssetForm == false &&
            this.toggleEditAssetForm == false &&
            this.toggleDeleteAssetForm == false
        "
      >
       
         <div class="tab-parent">

            <button id="assets-button" class="bar-item selected-tab" @click="toggleView('assets')"
            >

              <i class="fa fa-digital-tachograph"></i> Assets
            </button>
         
            <button id="contacts-button" class="bar-item" @click="toggleView('contacts')">
              <i class="fas fa-users"></i> Team
            </button>

           <!-- <button id="maintenance-button" class="bar-item" @click="toggleView('maintenance')">
              <i class="fas fa-users"></i> Maintenance
            </button> -->
          </div>

<!--         
 <el-radio-group v-model="view">
 
      <el-radio-button border="true" size="medium" label="Assets"></el-radio-button>
      
      <el-radio-button  border="true" size="medium" label="Contacts"></el-radio-button>
    </el-radio-group> -->


      <div
      >
            
        <div id="assets" ref="assets" v-show="assets == true">
            
            <div id="Asset-Cards" class="tab Asset-Cards Asset-Cardswindow">
              <div v-if="this.loadingAssets" class="loader">Loading...</div>
              <div v-else>
                <div
                  v-if="this.propertyassets.machinelists.length == 0"
                  style="padding:5%; color:gray;"
                >
                  <h1
                    v-if="this.propertyData.ownerfirstname + this.propertyData.ownerlastname == this.user.firstname + this.user.lastname"
                  >please click the + button to add a asset</h1>
                  <h1 v-else>please ask the manager to add an asset</h1>
                </div>

                <div class="cards">
                  <el-card
                    class="mycard asset-card"
                          style="min-width:320px;" 

                    v-for="machine in this.propertyassets.machinelists"
                    :key="machine.machineid"
                  >
                    <div>
                      
                      <router-link :to="{ path: `/MachinebyId/${machine.machineid}` }" tag="div">
                        <el-row>
                          <el-col :span="7">
                            <div>
                              <img
                                class="assetimage"
                                :src="machine.imageurl[0]"
                                style="max-width: 100%;"
                              />
                            </div>
                          </el-col>
                          <el-col :span="17" style="padding-left:3%">
                            <el-row>
                              <el-col :span="20">
                                <div style="color: rgb(89, 89, 89);" class="truncate-text">{{ machine.machinename }}</div>
                              </el-col>
                              <el-col :span="4">
                                <div>
                               <el-dropdown
                                    v-if="machine.permissions.candelete == true || machine.permissions.canedit == true "
                                    trigger="click"
                                    style="margin-top:-10px;"
                                  >
                                    <el-button v-on:click.stop type="text">
                                      <i class="el-icon-s-operation"></i>
                                    </el-button>
                                    <el-dropdown-menu slot="dropdown">
                                      <el-dropdown-item>
                                        <el-button
                                          v-if="machine.permissions.canedit == true"
                                          @click.native="
                                            toggleEditAssetFormmethod(machine)
                                          "
                                          type="text"
                                          style="margin-left:5px; margin-right:5px; color:#000000;"
                                        >
                                          <i class="fa fa-edit mt-2" /> Edit
                                          Asset
                                        </el-button>
                                      </el-dropdown-item>

                                      <el-dropdown-item>
                                        <el-button
                                          v-if="machine.permissions.candelete == true"
                                          type="text"
                                          @click.native="
                                            toggledeleteassetformmethod(machine)
                                          "
                                          style="margin-left:5px; margin-right:5px; color:#000000;"
                                        >
                                          <i class="fa fa-trash mt-2" /> Delete
                                          Asset
                                        </el-button>
                                      </el-dropdown-item>
                                    </el-dropdown-menu>
                                  </el-dropdown>
                                </div>
                              </el-col>
                            </el-row> 
                            <div style="text-align:left; color: rgb(89, 89, 89);">
                              <i class="fa fa-calendar-day"></i>
                              {{
                              machine.installdate
                              | moment(
                              "timezone",
                              $timeZone,
                              "MMM DD YYYY hh:mm A"
                              )
                              }}
                            </div>
                          </el-col>
                        </el-row>
                      </router-link>
                    </div>

                      <template>

                              <el-badge v-if="machine.unreadlogcount > 0" style="left:260px;" :value="machine.unreadlogcount">
                                  <i style="color: rgb(128, 128, 128);" class="fa-lg far fa-sticky-note"></i>
                              </el-badge>

                              <el-badge v-if="machine.unreadcommentcount > 0" style="left:200px;" :value="machine.unreadcommentcount">
                                <i style="color: rgb(128, 128, 128);" class="fa-lg far fa-comment-dots"></i>  <i ></i>
                              </el-badge>

                    </template>
                    
                  </el-card>
                  <div class="mycard" style="min-width:320px;" />
                  <div class="mycard" style="min-width:320px;" />
                  <div class="mycard" style="min-width:320px;" />
                </div>
              </div>
             <div v-if="this.propertyassets !=  null">
               <fab
              class="tst-add-asset"
              v-if="this.propertyassets.cancreateasset == true"
              position="bottom-right"
              bg-color="#02746E"
              icon="add"
              @click.native="toggleCreateAssetFormmethod()"
            ></fab>
             </div>
            </div>
            


            <div id="Asset-Table" class="tab Asset-Table Asset-Tablewindow">
           <div v-if="this.loadingAssets" class="loader">Loading...</div>
               <div v-if="this.propertyassets !=  null">

                <div
                  v-if="this.propertyassets.machinelists.length == 0"
                  style="padding:5%; color:gray;"
                >
                  <h1
                    v-if="this.propertyData.ownerfirstname + this.propertyData.ownerlastname == this.user.firstname + this.user.lastname"
                  >please click the + button to add a asset</h1>
                  <h1 v-else>please ask the manager to add an asset</h1>
                </div>

              <AssetsOfPropertyTable
              v-show="this.propertyassets.machinelists.length > 0"
              :machinesofproperty="this.propertyassets.machinelists"
               />
              <fab
              class="tst-add-asset"
              v-if="this.propertyassets.cancreateasset == true"
              position="bottom-right"
              bg-color="#02746E"
              icon="add"
              @click.native="toggleCreateAssetFormmethod()"
            ></fab>
            </div>

            </div>
      </div>
        
      <div id="contacts" ref="contacts" v-show="assets == false">
              <PropertyUsers class="contacts-section" :property="this.propertyData" />
            </div>

       <!-- <div id="maintenance" ref="maintenance" style="display:none">
   <maintenanceViewer></maintenanceViewer>
       </div> -->

          </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions, mapState } from "vuex";
import EventService from "@/services/EventService.js";
import AssetsOfPropertyTable from "@/components/assets/AssetsOfPropertyTable.vue";
import PropertyUsers from "@/components/team/PropertyUsers.vue";
import CreateAssetForm from "@/components/assets/CreateAssetForm.vue";
import EditAssetForm from "@/components/assets/EditAssetForm.vue";
import DeleteAssetForm from "@/components/assets/DeleteAssetForm.vue";
// import maintenanceViewer from "@/components/maintenance/maintenanceViewer.vue"
import fab from "vue-fab";

export default {
  components: {
    PropertyUsers,
    AssetsOfPropertyTable,
    CreateAssetForm,
    EditAssetForm,
    DeleteAssetForm,
    // maintenanceViewer,
    fab
  },
  data() {
    return {
      propertyData: [],
      toggleCreateAssetForm: false,
      toggleEditAssetForm: false,
      toggleDeleteAssetForm: false,
      currenteditedasset: {},
      currentdeletingasset: {},
      sortmode: undefined,
      search: "",
      propertyassets: null,
      propertyissues: null,
      listview: true,
      cardview: false,
      loadingProperty: false,
      loadingAssets: false,
      loadingIssues: false,
      view: "Assets",
      propertyid: this.$route.params.propertyid,
      assets: true
    };
  },
  methods: {


    showAssets(){
     this.assetsView = true;
     this.contactsView = false;
    },

    showContacts(){
     this.assetsView = false;
     this.contactsView = true;
    },


    toggleView(tabToviewRef) {
    
    //var tabToView = document.getElementById(tabToviewRef);
    if(tabToviewRef == "contacts"){
    //var tabToView = this.$refs.contacts;
       this.assets = false;
    } else if(tabToviewRef == "assets"){
    // var tabToView = this.$refs.assets;
       this.assets = true;
    }
    //  else if(tabToviewRef == "maintenance"){
    //   var tabToView = this.$refs.maintenance;
    // }
   // tabToView.style.display = "unset"
 
    var assetButton = document.getElementById("assets-button");

    var contactsButton = document.getElementById("contacts-button");

   // var maintenanceButton = document.getElementById("maintenance-button");

    if(tabToviewRef == "assets"){
    
    // assetButton.style.backgroundColor = "#02746E"
    // assetButton.style.color = "white"
    
    // contactsButton.style.backgroundColor = "white"
    // contactsButton.style.color = "black"
    
    // maintenanceButton.stylebackgroundColor = "white";
    // maintenanceButton.style.color = "black"
   assetButton.classList.remove("not-selected-tab")
   assetButton.classList.add("selected-tab")
         contactsButton.classList.remove("selected-tab")
  // maintenanceButton.classList.remove("selected-tab")
   contactsButton.classList.add("not-selected-tab")
//   maintenanceButton.classList.add("not-selected-tab")

    //var tabToHide = document.getElementById("contacts");
  //  this.$refs.contacts.style.display = "none"; 
  //  this.$refs.maintenance.style.display = "none"

    } else if(tabToviewRef == "contacts"){

    // contactsButton.style.backgroundColor = "#02746E"
    // contactsButton.style.color = "white"
    
    // assetButton.style.backgroundColor = "white"
    // assetButton.style.color = "black"


    // maintenanceButton.style.backgroundColor = "white";
    // maintenanceButton.style.color = "black"
  contactsButton.classList.remove("not-selected-tab")
  contactsButton.classList.add("selected-tab")
     assetButton.classList.remove("selected-tab")
  // maintenanceButton.classList.remove("selected-tab")
   assetButton.classList.add("not-selected-tab")
 //  maintenanceButton.classList.add("not-selected-tab")
   //  var tabToHide = document.getElementById("assets");

 //    this.$refs.assets.style.display = "none"
   //  this.$refs.maintenance.style.display = "none"
    } else {

    // maintenanceButton.style.backgroundColor = "#02746E"
    // maintenanceButton.style.color = "white"
    
    // assetButton.style.backgroundColor = "white"
    // assetButton.style.color = "black"


    // contactsButton.stylebackgroundColor = "white";
    // contactsButton.style.color = "black"

 //maintenanceButton.classList.remove("not-selected-tab")
// maintenanceButton.classList.add("selected-tab")
    assetButton.classList.remove("selected-tab")
   contactsButton.classList.remove("selected-tab")
   assetButton.classList.add("not-selected-tab")
   contactsButton.classList.add("not-selected-tab")

   //  var tabToHide = document.getElementById("assets");

    //  this.$refs.assets.style.display = "none"
    //  this.$refs.contacts.style.display = "none"

    }
    if(tabToviewRef == "assets"){

          // this.$router.push("#assets").catch(err => {});
             this.$router.replace("#assets");

      } else if(tabToviewRef == "contacts"){

          // this.$router.push("#contacts").catch(err => {});
             this.$router.replace("#contacts")
      }
      // else if(tabToviewRef == "maintenance"){

    //       this.$router.push("#maintenance").catch(err => {});
    //  }
    },
    closeFormsFromBackButton() {
      this.toggleCreateAssetForm = false;
      this.toggleEditAssetForm = false;
      this.toggleDeleteAssetForm =false;
    },
    changeBackButton() {
      this.$root.$emit("form-toggled");
    },
    toggleCreateAssetFormmethod() {
      this.toggleCreateAssetForm = !this.toggleCreateAssetForm;
      this.changeBackButton();
    },
    toggleEditAssetFormmethod(machine) {
      this.toggleEditAssetForm = !this.toggleEditAssetForm;
      this.currenteditedasset = machine;
      this.changeBackButton();
    },
    toggledeleteassetformmethod(machine) {
      this.toggleDeleteAssetForm = !this.toggleDeleteAssetForm;
      this.currentdeletingasset = machine;
      this.changeBackButton();
    },

    // toggleview() {
    //   this.listview = !this.listview;
    //   this.cardview = !this.cardview;
    // },
    searchAssets() {
      return this.sortedAssets.filter(machine =>
        machine.machinename.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    ...mapActions(["getSpecificProperty", "newTitle"]),
    // ...mapActions(["getMachinesOfSpecificProperty"]),
    addNewAssetLocally(newasset) {
      this.propertyassets.machinelists.push(newasset);
    },
    addNewAssetListLocally($event){
      $event.machinereturnmodel.forEach(machine => {
         this.propertyassets.machinelists.push(machine);
      });
    },
    updateAssetLocally(updatedassetpackage) {
      this.$set(
        this.propertyassets.machinelists,
        this.propertyassets.machinelists.indexOf(updatedassetpackage[1]),
        updatedassetpackage[0]
      );
    },
    // openAsset(machine) {
    //   this.$router.push({
    //     path: `/MachinebyId/${machine.machineid}`
    //   });
    // },
    deleteAssetLocally($event) {
      console.log("delete asset locally is running" + $event);
      // console.log(
      //   "this is the index of the property " +
      //     this.propertyassets.indexOf($event)
      // );
      this.$delete(
        this.propertyassets.machinelists,
        this.propertyassets.machinelists.indexOf($event)
      );
    }
  },
  created() {
    // window.location.pathname.split("/").pop()
    this.loadingProperty = true;
    this.loadingAssets = true;
    this.loadingIssues = true;
    EventService.getPropertybyId(this.$route.params.propertyid)
      .then(response => {
        this.propertyData = response.data;
        this.newTitle(this.propertyData.propertyname);

        // this.$root.$emit("topbartextchange", response.data.propertyname);
      })
      .then(() => {
        this.loadingProperty = false;
      });
    EventService.getMachinesofProperty(this.$route.params.propertyid)
      .then(response => {
        this.propertyassets = response.data;

        })
      .then(() => (this.loadingAssets = false));
    // EventService.GetIssuesOfProperty(this.$route.params.propertyid, "all")
    //   .then(response => (this.propertyissues = response.data))
    //   .then(() => (this.loadingIssues = false));

    // this.getMachinesOfSpecificProperty(this.$route.params.propertyid);
  },
  mounted() {

    this.$root.$on("close-form", () => this.closeFormsFromBackButton());
  },

  updated(){
  // var section = this.$router.currentRoute.hash.replace("#", "");
  //  if (section == "assets"){
  //        this.toggleView('assets')
  //     } else if (section == "contacts"){
  //      this.toggleView('contacts')
  //      } 
  //      //else if (section == "maintenance"){
  //      //   this.toggleView('maintenance')
  //    // } 
  //     else {
  //    this.$router.push("#assets").catch(err => {});
  //     }
  },
  computed: {
    ...mapState({
      user: state => state.user.user
    }),
    sortedAssets: function() {
      function compare(a, b) {
        if (a.machinename.toUpperCase() < b.machinename.toUpperCase())
          return -1;
        if (a.machinename.toUpperCase() > b.machinename.toUpperCase()) return 1;
        return 0;
      }
      if (this.sortmode == "alphabetical") {
        return this.propertyassets.machinelists.slice().sort(compare);
      }
      return this.propertyassets.machinelists;
    }
  }
};
</script>
<style scoped>
h1{
  text-align: center;
}
h3{
  text-align: center;
}
.assetimage {
  max-height: 200px;
  height: 80px;
}
.machinesection {
}

.mycard{
  margin-bottom: 15px;
}

.tab-parent {
  min-width: 100%;
  top: 60px;
  text-align: center;
  position: fixed;
  background-color: white;
  z-index: 2;
}

.bar-item {
  padding: 8px 16px;
  color: black;
  border: 1px lightgray solid;
  border-radius: 2px;
  background-color: white;
  outline: 0;
  min-width: 150px;
  width: 25%;
  cursor: pointer;
}

.machinetableimage {
  max-height: 50px;
}
table {
  font-family: "Open Sans", sans-serif;
  width: 750px;
  border-collapse: collapse;
  border: 3px solid #44475c;
  margin: 10px 10px 0 10px;
}

table th {
  text-transform: uppercase;
  text-align: left;
  background: #44475c;
  color: #fff;
  padding: 8px;
  min-width: 30px;
}

table td {
  text-align: left;
  padding: 8px;
  border-right: 2px solid #7d82a8;
}
table td:last-child {
  border-right: none;
}
table tbody tr:nth-child(2n) td {
  background: #dcdcdc;
}

.titlecard {
  background-color: #e4e4e4;
  border-radius: 3px;
  padding-right: 5px;
}

/* // asset card table toggle */

.bar-item {
  padding: 8px 16px;
  color: black;
  border: 1px lightgray solid;
  border-radius: 2px;
  background-color: white;
  outline: 0;
}

.mmm {
  padding: 0%;
}

.cards{
  margin: 2%;
}

#Asset-Cards{
  display: none;
}

#contacts{
    width: 85%;
}

.contacts-section{
   margin-top: 120px;
}

.Asset-Table{
   margin-top: 120px;
}
.selected-tab{
    background-color: #02746E;
    color:white;
}
.not-selected-tab{
   background-color: white;
   color: black;
}
@media screen and (max-width: 720px) {
 #Asset-Cards{
  display: block;
  margin-top: 110px;
}

.contacts-section{
   margin-top: 110px;
}

.Asset-Table{
  display: none;
}
}
</style>
